<template>
	<v-main style="padding: 0px 0px 0px 0px">
		<h1 style="margin-bottom: 10px; color: black">Consultation Booking</h1>
		<div>
			<v-card>
				<v-card-text>
					<v-data-table :headers="headers" :items="booking" no-data-text="No consultation booking.">
						<template v-slot:item.actions="{ item }">
							<v-icon small class="mr-2" @click="editBook(item)">mdi-pencil</v-icon>
							<v-icon small color="red" @click="deleteBook(item.reqId)">mdi-delete</v-icon>
						</template>
					</v-data-table>
				</v-card-text>
			</v-card>
		</div>

		<v-dialog
			no-click-animation
			persistent
			transition="dialog-bottom-transition"
			content-class="col-sm-7 col-12 pa-0 hide-box-shadow"
			style="overflow: auto"
			v-model="showEdit"
		>
			<v-flex row-wrap justify-center>
				<v-row align="center" justify="center">
					<v-col class="pa-0">
						<v-card>
							<v-card-title class="headline">
								Update
								<v-spacer></v-spacer>
								<v-btn icon @click="showEdit = waitProcess == false ? false : true">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text class="pa-5" v-if="!waitProcess">
								<v-text-field readonly v-model="updateBook.clientName" label="Name"> </v-text-field>

								<v-text-field readonly v-model="updateBook.clientEmail" label="Email"> </v-text-field>

								<v-text-field readonly v-model="updateBook.clientPhone" label="Phone"> </v-text-field>

								<v-textarea readonly v-model="updateBook.clientRequirement" label="Note"></v-textarea>

								<v-row>
									<v-col cols="12" class="my-n4">
										<v-select
											:items="statusItem"
											item-text="text"
											item-value="value"
											label="Status"
											v-model="updateBook.isApproved"
											:disabled="waitProcess"
											outlined
										></v-select>
									</v-col>
								</v-row>
								<p></p>

								<v-menu
									ref="menu"
									v-model="consulDate"
									:close-on-content-click="false"
									:return-value.sync="updateBook.aptDateTime"
									transition="scale-transition"
									offset-y
									min-width="290px"
									v-if="updateBook.isApproved == 1"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="updateBook.aptDateTime"
											label="Pick date"
											prepend-icon="mdi-calendar"
											:disabled="waitProcess"
											readonly
											autocomplete="off"
											v-bind="attrs"
											v-on="on"
											
										></v-text-field>
									</template>
									<v-date-picker
										:min="new Date().toISOString().substr(0, 10)"
										v-model="updateBook.aptDateTime"
										@input="updateBook.aptDateTime = changeDatetime(updateBook.aptDateTime)"
										no-title
										scrollable
										:disabled="waitProcess"
										color="primary"
										:rules="[(v) => !!v || 'Start Date is required']"
										required
									>
										<div class="d-flex flex-column" style="width: 100%">
											<div class="d-flex flex-row align-space-arround">
												<span>Time</span>
												<v-select
													v-model="hour"
													:items="
														Array(24)
															.fill()
															.map((x, i) => ('' + i).padStart(2, '0'))
													"
													class="mx-2"
													style="width: 10px"
													dense
													append-icon="false"
													@input="updateBook.aptDateTime = changeDatetime(updateBook.aptDateTime)"
												>
													<template
														v-slot:selection="{
															item,
														}"
													>
														<span v-if="item" class="d-flex justify-center pl-6" style="width: 100%">{{ item }}</span>
													</template> </v-select
												>:
												<v-select
													v-model="minute"
													:items="
														Array(60)
															.fill()
															.map((x, i) => ('' + i).padStart(2, '0'))
													"
													class="mx-2"
													style="width: 10px"
													dense
													append-icon="false"
													@input="updateBook.aptDateTime = changeDatetime(updateBook.aptDateTime)"
												>
													<template
														v-slot:selection="{
															item,
														}"
													>
														<span v-if="item" class="d-flex justify-center pl-6" style="width: 100%">{{ item }}</span>
													</template> </v-select
												>:
												<v-select
													v-model="second"
													:items="
														Array(60)
															.fill()
															.map((x, i) => ('' + i).padStart(2, '0'))
													"
													class="mx-2"
													style="width: 10px"
													dense
													append-icon="false"
													@input="updateBook.aptDateTime = changeDatetime(updateBook.aptDateTime)"
												>
													<template
														v-slot:selection="{
															item,
														}"
													>
														<span v-if="item" class="d-flex justify-center pl-6" style="width: 100%">{{ item }}</span>
													</template>
												</v-select>
											</div>
											<v-divider></v-divider>
											<div class="d-flex justify-end">
												<v-btn text color="primary" @click="(consulDate = false), resetTime()">Cancel</v-btn>
												<v-btn
													text
													color="primary"
													@click="$refs.menu.save((updateBook.aptDateTime = changeDatetime(updateBook.aptDateTime)))"
													>OK</v-btn
												>
											</div>
										</div>
									</v-date-picker>
								</v-menu>

								<v-text-field
									label="Zoom Link"
									v-model="updateBook.zoomLink"
									v-if="updateBook.isApproved == 1"
									:disabled="waitProcess"
									:rules="[(v) => !!v || 'Zoom Link is required']"
									required
								></v-text-field>

								<v-textarea
									label="Note"
									v-model="updateBook.notes"
									v-if="updateBook.isApproved != -1"
									:disabled="waitProcess"
								></v-textarea>
								<p></p>
								&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
								<v-btn
									class="green darken-1"
									type="button"
									@click="saveAndEmail"
									dark
									:disabled="waitProcess"
									v-if="updateBook.isApproved != -1"
									>Save and Email</v-btn
								>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
								<v-btn class="green darken-1" type="button" @click="saveBook" dark :disabled="waitProcess">Save</v-btn
								>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
								<v-btn
									class="green darken-1"
									type="button"
									@click="sendEmail"
									dark
									:disabled="waitProcess"
									v-if="updateBook.isApproved != -1"
									>Email</v-btn
								>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
								<v-btn class="red darken-1" type="button" @click="(showEdit = false), resetTime()" dark :disabled="waitProcess"
									>Cancel</v-btn
								>
							</v-card-text>
							<v-card-text class="pa-5" v-if="waitProcess"></v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-flex>
		</v-dialog>
	</v-main>
</template>

<style scoped>
.text-table .v-table tbody tr td {
	max-width: 100px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.v-dialog {
	box-shadow: none !important;
}

.row {
	margin-right: 0 !important;
}

.v-picker__body {
	flex: none !important;
}
</style>

<script>
import axios from "axios";

export default {
	data() {
		return {
			search: "",
			searchName: null,
			searchDate: null,
			statusItem: [
				{ text: "Haven't Decided", value: -1 },
				{ text: "Approve", value: 1 },
				{ text: "Reject", value: 0 },
			],
			booking: [],
			headers: [
				{ text: "ID", value: "reqId", sortable: true, align: " d-none" },
				{ text: "Created", value: "reqCreated", sortable: true },
				{ text: "Updated", value: "reqUpdated", sortable: true },
				{ text: "Name", value: "reqName", sortable: true },
				{ text: "Email", value: "reqEmail", sortable: true },
				{ text: "Phone", value: "reqPhone", sortable: true },
				{ text: "Requirement", value: "req", sortable: true },
				{ text: "Status", value: "reqStatus", sortable: true },
				{ text: "Emailed ?", value: "reqNotice", sortable: true },
				{ text: "Appointment", value: "reqAptDateTime", sortable: true },
				{ text: "Zoom Link", value: "reqZoom", sortable: true },
				{ text: "Notes", value: "reqNotes", sortable: true },
				{ text: "Action", value: "actions", sortable: true },
			],
			isShowStart: false,
			isShowEnd: false,
			roomList: [],
			selectedRoom: null,
			selectedBrowseRoom: null,
			processing: false,
			showEdit: false,
			updateBook: {
				id: null,
				slug: null,
				clientName: null,
				clientEmail: null,
				clientPhone: null,
				clientRequirement: null,
				isApproved: -1,
				isEmailed: null,
				aptDateTime: null,
				aptDate: null,
				aptTime: null,
				zoomLink: null,
				notes: null,
				transitMap: {},
			},
			selectedStatus: -1,
			aptDateTime: "",
			zoomLink: "",
			notes: "",
			consulDate: false,
			consulTime: false,
			searchConsulDate: false,
			waitProcess: false,
			today: new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate(),
			hour: "00",
			minute: "00",
			second: "00",
		};
	},
	props: ["experienceId"],
	created: async function () {
		await this.getList();
	},
	methods: {
		saveAndEmail() {
			this.sendEmail();
		},
		sendEmail() {
			this.updateBook.isApproved = this.updateBook.isApproved == 1 ? true : this.updateBook.isApproved == 0 ? false : null;
			this.updateBook.transitMap.aptDateTime = this.updateBook.isApproved == true ? this.updateBook.aptDateTime : undefined;
			this.updateBook.aptDateTime = undefined;
			this.pleaseWait();
			axios
					.post("/system/clinic/book/send/email", {
					entity: this.updateBook,
					tenantSlug: this.$store.state.principal.tenantSlug,
					experienceId: this.experienceId
				})
				.then(() => {
					this.pleaseContinue();
					this.updateBook.isEmailed = true;
					this.showEdit = false;
					this.getList();
					alert("Email sent!");
				})
				.catch(() => {
					this.pleaseContinue();
					this.showEdit = false;
				});
		},
		saveBook() {
			this.updateBook.isApproved = this.updateBook.isApproved == 1 ? true : this.updateBook.isApproved == 0 ? false : null;
			this.updateBook.transitMap.aptDateTime = this.updateBook.isApproved == true ? this.updateBook.aptDateTime : undefined;
			this.updateBook.aptDateTime = undefined;
			this.updateBook.zoomLink = this.updateBook.isApproved == true ? this.updateBook.zoomLink : null;
			this.updateBook.notes = this.updateBook.isApproved == null ? null : this.updateBook.notes;

			this.pleaseWait();
			axios
				.post("/system/clinic/book/update", {
					entity: this.updateBook,
				})
				.then(() => {
					this.pleaseContinue();
					this.showEdit = false;
					this.getList();
					alert("Saved!");
					this.resetTime();
				})
				.catch(() => {
					this.pleaseContinue();
					this.showEdit = false;
				});
		},
		editBook(item) {
			this.updateBook.slug = this.experienceId;

			this.updateBook.id = item.reqId;
			this.updateBook.updated = item.reqUpdated;
			this.updateBook.clientName = item.reqName;
			this.updateBook.clientEmail = item.reqEmail;
			this.updateBook.clientPhone = item.reqPhone;

			this.updateBook.isApproved = item.reqStatus == "Rejected" ? 0 : item.reqStatus == "Approved" ? 1 : -1;
			this.updateBook.isEmailed = item.reqNotice == "Yes" ? true : false;
			this.updateBook.clientRequirement = item.req;

			this.updateBook.aptDateTime = item.transitMap.aptDateTime;

			this.updateBook.zoomLink = item.reqZoom;
			this.updateBook.notes = item.reqNotes;

			this.showEdit = true;
		},
		async getList() {
			axios
				.get("/system/clinic/book/list?id=" + this.experienceId)
				.then((response) => {
					this.booking = [];

					for (var i = 0; i < response.data.length; i++) {
						this.booking.push({
							reqId: response.data[i].id,
							reqCreated: this.formatDate(
								response.data[i].created.date.year,
								response.data[i].created.date.month,
								response.data[i].created.date.day,
								response.data[i].created.time.hour,
								response.data[i].created.time.minute,
								response.data[i].created.time.second
							),
							reqUpdated:
								response.data[i].edited != null
									? this.formatDate(
											response.data[i].edited.date.year,
											response.data[i].edited.date.month,
											response.data[i].edited.date.day,
											response.data[i].edited.time.hour,
											response.data[i].edited.time.minute,
											response.data[i].edited.time.second
									)
									: "-",

							reqName: response.data[i].clientName,
							reqEmail: response.data[i].clientEmail,
							reqPhone: response.data[i].clientPhone,
							req: response.data[i].clientRequirement,
							reqStatus:
								response.data[i].isApproved == null ? "Haven't Decided" : response.data[i].isApproved == 1 ? "Approved" : "Rejected",
							reqNotice: response.data[i].isEmailed == 0 ? "No" : "Yes",
							reqAptDateTime:
								response.data[i].isApproved == 1
									? this.formatDate(
											response.data[i].aptDateTime.date.year,
											response.data[i].aptDateTime.date.month,
											response.data[i].aptDateTime.date.day,
											response.data[i].aptDateTime.time.hour,
											response.data[i].aptDateTime.time.minute,
											response.data[i].aptDateTime.time.second
									)
									: "",
							reqZoom: response.data[i].zoomLink,
							reqNotes: response.data[i].notes,
							actions: "-",
							transitMap: response.data[i].transitMap,
						});
					}
					this.processing = false;
				})
				.catch(() => {});
		},
		deleteBook(id) {
			if (confirm("Are you sure you want to delete?")) {
				axios.post("/system/clinic/book/delete", { id: id }).then(() => {
					this.getList();
				});
			}
		},
		pleaseWait() {
			this.waitProcess = true;
		},
		pleaseContinue() {
			this.waitProcess = false;
		},
		changeDatetime(dateTime) {
			if (dateTime === "") {
				return this.today + " " + this.hour + ":" + this.minute + ":" + this.second;
			} else {
				return dateTime.substr(0, 10) + " " + this.hour + ":" + this.minute + ":" + this.second;
			}
		},
		resetTime() {
			this.hour = "00";
			this.minute = "00";
			this.second = "00";
		},
		formatDate(year, month, day, hour, minute, second) {
			let date = new Date(year, month, day, hour, minute, second);
			let options = {
				year: "numeric",
				month: "long",
				day: "numeric",
				hour: "2-digit",
				minute: "2-digit",
				second: "2-digit",
			};

			let formattedDate = date.toLocaleString("en-US", options).split(" ");
			let result =
				formattedDate[1].replace(",", "") +
				" " +
				formattedDate[0] +
				" " +
				formattedDate[2].replace(",", "") +
				" " +
				formattedDate[3] +
				" " +
				formattedDate[4];
			return result;
		},
	},
};
</script>